// extracted by mini-css-extract-plugin
export default {"container":"AllMovies_container__F+Xbb","movies":"AllMovies_movies__kCTJT","movie_slider":"AllMovies_movie_slider__9Y5pj"};